import React from 'react';
import { IGenericIconProps } from './types';
import theme from '../../../theme';

const ChevronRight: React.FC<IGenericIconProps> = ({
    width = 20,
    height = 20,
    strokeColor = theme.colors.white,
    strokeWidth = 1.5
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
        <path
            d="M7.5 5L12.5 10L7.5 15"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export { ChevronRight };
